'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_Lcom_raquo_laminar_keys_CompositeKey$() {
}
export { $c_Lcom_raquo_laminar_keys_CompositeKey$ as $c_Lcom_raquo_laminar_keys_CompositeKey$ };
$p = $c_Lcom_raquo_laminar_keys_CompositeKey$.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Lcom_raquo_laminar_keys_CompositeKey$;
/** @constructor */
function $h_Lcom_raquo_laminar_keys_CompositeKey$() {
}
export { $h_Lcom_raquo_laminar_keys_CompositeKey$ as $h_Lcom_raquo_laminar_keys_CompositeKey$ };
$h_Lcom_raquo_laminar_keys_CompositeKey$.prototype = $p;
$p.C8 = (function(items, separator) {
  if ((items === "")) {
    return $j_java$002elang$002e$002dObject.$m_sci_Nil$();
  } else {
    var this$10 = $j_java$002elang$002e$002dObject.$ct_sjs_js_WrappedArray__sjs_js_Array__(new $j_java$002elang$002e$002dObject.$c_sjs_js_WrappedArray(), items.split(separator).filter(((_$1) => {
      $j_java$002elang$002e$002dObject.$m_sc_StringOps$();
      return (_$1 !== "");
    })));
    $j_java$002elang$002e$002dObject.$m_sci_List$();
    return $j_java$002elang$002e$002dObject.$m_sci_Nil$().bW(this$10);
  }
});
var $d_Lcom_raquo_laminar_keys_CompositeKey$ = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lcom_raquo_laminar_keys_CompositeKey$, "com.raquo.laminar.keys.CompositeKey$", ({
  ie: 1
}));
export { $d_Lcom_raquo_laminar_keys_CompositeKey$ as $d_Lcom_raquo_laminar_keys_CompositeKey$ };
var $n_Lcom_raquo_laminar_keys_CompositeKey$;
function $m_Lcom_raquo_laminar_keys_CompositeKey$() {
  if ((!$n_Lcom_raquo_laminar_keys_CompositeKey$)) {
    $n_Lcom_raquo_laminar_keys_CompositeKey$ = new $c_Lcom_raquo_laminar_keys_CompositeKey$();
  }
  return $n_Lcom_raquo_laminar_keys_CompositeKey$;
}
export { $m_Lcom_raquo_laminar_keys_CompositeKey$ as $m_Lcom_raquo_laminar_keys_CompositeKey$ };
